<template>
  <div>

    <div style="display: flex; justify-content: space-between;">
      <div style="width: 49%; text-align: left;">
        <h4 style="text-align: left;">批量删除指定范围Logs</h4>
        <el-form label-width="100px">

          <el-form-item label="ID 范围">
            <el-input v-model="idRange" placeholder="格式'id1_id2'" style="width: 400px;"></el-input>
          </el-form-item>

          <el-form-item label="此日期以前">
            <el-date-picker v-model="delDateBefore" type="date" placeholder="选择日期" format="yyyy-MM-dd"
              value-format="yyyy-MM-dd" style="width: 400px;">
            </el-date-picker><!-- 这里确保输出为yyyy-MM-dd格式 -->
          </el-form-item>

          <el-form-item label="删除的类型">
            <el-select v-model="delLevel" placeholder="请选择层级" style="width: 400px;">
              <el-option label="只有INFO" value="info"></el-option>
              <el-option label="NOTICE以下" value="notice"></el-option>
              <el-option label="WARN 以下" value="warn"></el-option>
              <el-option label="全部类型" value="all"></el-option>
            </el-select>
          </el-form-item>


          <el-form-item>
            <el-button @click="handleDelete" type="danger">删除Logs</el-button>
          </el-form-item>

        </el-form>
      </div>


      <div style="width: 49%; text-align: left;">
        <h4 style="text-align: left;">重新获取指定范围 Logs</h4>
        <el-form label-width="100px">


          <el-form-item label="最大条数">
            <el-input v-model="count" placeholder="请输入最大条数,默认200" style="width: 400px;"></el-input>
          </el-form-item>

          <el-form-item label="此日期以前">
            <el-date-picker v-model="getDateBefore" type="date" placeholder="选择日期" format="yyyy-MM-dd"
              value-format="yyyy-MM-dd" style="width: 400px;">
            </el-date-picker>
          </el-form-item>

          <el-form-item label="获取的层级">
            <el-select v-model="getLevel" placeholder="请选择层级" style="width: 400px;">
              <el-option label="只有 ERROR" value="error"></el-option>
              <el-option label="WARN 以上" value="warn"></el-option>
              <el-option label="NOTICE 以上" value="notice"></el-option>
              <el-option label="全部类型" value="all"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="包含关键字">
            <el-input v-model="keywords" placeholder="请输入关键字,不区分大小写" style="width: 400px;"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button @click="handleGetLogs" type="primary">获取 Logs</el-button>
          </el-form-item>

        </el-form>
      </div>
    </div>
    <el-divider></el-divider>

    <el-table :data="tableData" stripe style="width: 100%;white-space:pre-wrap" height="950"
      :default-sort="{ prop: 'id', order: 'descending' }">
      <el-table-column prop="id" label="编号" width="90" sortable>
      </el-table-column>
      <el-table-column prop="level" label="level" width="120">
      </el-table-column>
      <el-table-column prop="message" label="message">
      </el-table-column>

      <el-table-column prop="timestamp" label="time" width="170">
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <el-button @click="handleClick(scope.row)" type="text" size="small">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

  </div>
</template>
<script>




export default {
  data() {
    return {
      tableData: [],

      idRange: '',
      delDateBefore: '',
      delLevel: 'info',

      count: '200',
      getDateBefore: '',
      getLevel: '',
      keywords: '',
    }
  },

  methods: {
    handleClick(row) {
      //  24年5月8日GPT4  帮忙修改, 避免全部重新刷新, 只是删除对应的数据行 提升效率
      // 合并到同一个删除逻辑
      const params = {
        idRange: row.id,
        dateBefore: '',
        delLevel: '',
      };

      this.$http.get("/da/del_logs", { params }).then((response) => {
        // 删除成功，移除表格中的数据
        this.tableData = this.tableData.filter(data => data.id !== row.id);
      })
        .catch((error) => {
          // 错误处理
          console.error(error);
          this.$message.error('删除失败');
        });
    },

    handleDelete() {
      const params = {
        idRange: this.idRange,
        delDateBefore: this.delDateBefore,
        delLevel: this.delLevel
      };

      this.$http.get("/da/del_logs", { params }).then((response) => {
        location.reload();
        //console.log(response);
      });
    },

    // handleGetLogs
    handleGetLogs() {
      const params = {
        count: this.count,
        getDateBefore: this.getDateBefore,
        getLevel: this.getLevel,
        keywords: this.keywords,
      };

      this.$http.get("/da/get_logs", { params }).then((response) => {
        this.tableData = response.data;
        console.log(response.data)
      });
    }

  },


  created: function () {
    //注意回调函数的作用域!!!
    this.handleGetLogs()
    //console.log(response.data)

  },



}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>